import * as React from "react";

const ChairLift = (props) => (
  <svg
    width={24}
    height={24}
    viewBox={"0 0 24 24"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 3 4 7M17.794 20h-4.457c-2.954 0-5.349-2.353-5.349-5.256v-3.257h4.903V5.48"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChairLift;
